module.exports = __webpack_public_path__ + "static/img/title.8ba2bd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/media5/title.png
// module id = Jvj3
// module chunks = 7